import { ref } from 'vue';
import { $api } from '@/services';

const error = ref(null);
const loading = ref(false);

export async function stats(date: string) {
	error.value = null;
	try {
		const e = date && date.length > 0 ? `?date=${date}` : '';
		const res = await $api.lessonReport.stats(e);
		if (!res) throw new Error('Lỗi');
		return res?.data;
	} catch (err) {
		error.value = err?.response?.data?.errors || err.message;
	} finally {
		loading.value = false;
	}
}

export function useStats() {
	return { error, loading, stats };
}
